const authHeader = (isfile) => {
    let user;
    if (process.browser) {
        user = JSON.parse(localStorage.getItem('user'));
    }

    const token = user ? user.token : null;

    if (token) {
        if (isfile) {
            return {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
            };
        } else {
            return {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            };
        }
    }
    if (isfile) {
        return {
            Accept: 'application/json',
        };
    } else {
        return {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        };
    }
};

const setHeader = (method = 'GET', isfile = false) => {
    if (method === 'GET') {
        return {
            method: method,
            headers: authHeader(),
        };
    } else {
        return {
            method: method,
            // credentials: "include",
            headers: authHeader(isfile),
        };
    }
};

const API_HOST = process.env.NEXT_PUBLIC_HOSTNAME;

// Token хүчингүй болсон (403 authentication.error) үед session-ийг цэвэрлэж
// login хуудас руу шилжүүлнэ. 403 нь middleware-д зөвхөн token-ы алдаанд хэрэглэгддэг.
const handleSessionExpiry = (response, hadToken) => {
    if (!process.browser) return;
    if (response.status !== 403 || !hadToken) return;

    localStorage.removeItem('user');
    if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin';
    }
};

const request = async (target, options) => {
    const hadToken = !!options.headers.Authorization;
    const response = await fetch(API_HOST + target, options);
    handleSessionExpiry(response, hadToken);
    return response.json();
};

export const get = async (target) => {
    return request(target, setHeader());
};

export const put = async (target, datas) => {
    const options = setHeader('PUT');
    options.body = JSON.stringify(datas);
    return request(target, options);
};

export const post = async (target, data) => {
    const options = setHeader('POST');
    options.body = JSON.stringify(data);
    return request(target, options);
};

export const destroy = async (target, datas) => {
    const options = setHeader('DELETE');
    options.body = JSON.stringify(datas);
    return request(target, options);
};

export const upload = async (target, data) => {
    const options = setHeader('POST', true);
    options.body = data;
    return request(target, options);
};
